export default  {
    namespaced: true,
    state: {
        wantNotifications: null,
        browserHasSupported: null,
        changeRotine: null
    },
    mutations: {
        set_wantNotification(state, wantNotifications) {
            if( wantNotifications != null) {
                state.wantNotifications = wantNotifications
            }
        },
        set_browserHasSupported(state, browserHasSupported) {
            if ( browserHasSupported != null) {
                state.browserHasSupported = browserHasSupported
            }
        },
        set_changeRotine(state, changeRotine){
           if ( changeRotine != null ) {
               state.changeRotine = changeRotine
           }
        }
    },
    actions: {
        SET_LOCAL_WANT_NOTIFICATION({commit}, wantNotifications) {
            commit('set_wantNotification', wantNotifications)
        },
        SET_LOCAL_BROWSER_HAS_SUPPORTED({commit}, browserHasSupported) {
            commit('set_browserHasSupported', browserHasSupported)
        },
        SET_CHANGE_ROTINE({commit}, changeRotine) {
            commit('set_changeRotine', changeRotine)
        }
    },
    getters: {
        get_wantNotification: state => state.wantNotifications,
        get_browserHasSupported: state => state.browserHasSupported,
        get_changeRotine: state => state.changeRotine
    }
}